import Component from '../vendor/Component'
import Helpers from '../qf/Helpers'

export default class Product extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._options = {
      ...{
        historyState: true
      }, ...this._options
    }
    this._product = this._elem.querySelector('[data-product-json]') ? JSON.parse(this._elem.querySelector('[data-product-json]').innerHTML) : null
    this._productVariantInventories = this._elem.querySelector('[data-product-variant-inventories-json]') ? JSON.parse(this._elem.querySelector('[data-product-variant-inventories-json]').innerHTML) : null
    // this._variantOptionTriggers = this._elem.querySelectorAll('[data-variant-option-trigger]')
    this._variantOptionTriggers = this._elem.querySelectorAll('[data-single-option-selector]')
    this._variant = null
    this._masterSelects = this._elem.querySelectorAll('[data-master-select]')
    this.activeOptionLabels = this._elem.querySelectorAll('[data-active-option-label]')
    this._priceWrappers = this._elem.querySelectorAll('[data-product-prices]')
    this._prices = this._elem.querySelectorAll('[data-price]')
    this._priceVaries = this._elem.querySelectorAll('[data-price-varies]')
    this._comparePrices = this._elem.querySelectorAll('[data-compare-price]')
    this._quantitySelects = this._elem.querySelectorAll('[data-quantity]')
    this._quantityMinus = this._elem.querySelectorAll('[data-quantity-minus]')
    this._quantityPlus = this._elem.querySelectorAll('[data-quantity-plus]')
    this._images = this._elem.querySelectorAll('[data-product-image]')
    this._addToCarts = this._elem.querySelectorAll('[data-add-to-cart]')
    this._addToCartHTML = Array.from(this._addToCarts).map(elem => elem.innerHTML)
    this._clearpayElem = false,
      this._clearpayTarget = this._elem.querySelector('[data-clearpay-target]')
    this._sizeSelectors = this._elem.querySelectorAll('.size-selector__item input')
    this._gallery = {
      mainSlider: this._theme.getComponent('mainProductSlider'),
      modalSlider: this._theme.getComponent('modalProductSlider'),
      thumbs: [...document.querySelectorAll('[data-gallery-thumb]')],
      thumbSlider: this._theme.getComponent('thumbProductSlider')
    }
  }

  mount() {
    if (this._product === null) {
      return false
    }

    this._variant = this._getVariantFromOptions()


    for (let optionSelector of this._variantOptionTriggers) {
      optionSelector.addEventListener('change', e => {
        this._onSelectChange()
      })
    }

    for (let minus of this._quantityMinus) {
      minus.addEventListener('click', e => {
        e.preventDefault()
        this._decrementQuantity()
      })
    }

    for (let plus of this._quantityPlus) {
      plus.addEventListener('click', e => {
        e.preventDefault()
        this._incrementQuantity()
      })
    }

    for (let select of this._quantitySelects) {
      select.addEventListener('click', e => {
        if (select.getAttribute('max')) {
          if (Number(select.value) > Number(select.getAttribute('max'))) {
            select.value = Number(select.getAttribute('max'))
          }
        }
      })
    }

    /**
     * Gallery controls.
     */

    // this._handleCarouselControls();
    this._onSelectChange()
    // this._moveClearpayElement();
  }

  _decrementQuantity() {
    for (let select of this._quantitySelects) {
      if (select.value > 1) {
        select.value = Number(select.value) - 1
      }
    }
  }

  _incrementQuantity() {
    for (let select of this._quantitySelects) {
      if (Number(select.value) != Number(select.getAttribute('max'))) {
        select.value = Number(select.value) + 1
      }
    }
  }

  _linkedOptions(variant) {
    for (let optionSelector of this._variantOptionTriggers) {
      optionSelector.removeAttribute('disabled')
      for (let prodVariant of this._product.variants) {
        if (prodVariant.option1 === variant.option1 && optionSelector.value === prodVariant.option2 && !prodVariant.available) {
          optionSelector.setAttribute('disabled', 'disabled')
        }
      }
    }
  }

  _onSelectChange() {
    let variant = this._getVariantFromOptions()

    this._updateAddToCartState(variant)

    if (!variant) {
      return
    }

    this._updateMasterSelect(variant)
    // this._updateProductPrices(variant)
    // this._switchToVariantImage(variant)
    // this._updateOptionLabels(variant)
    this._updateStockIndicator(variant)

    // this._linkedOptions(variant)
    this._variant = variant

    // if (this._options.historyState) {
    //   this._updateHistoryState(variant)
    // }
  }

  _updateStockIndicator(variant) {
    let currentStockEl = this._elem.querySelector('[data-current-stock-threshold]')
    let currentStockIntegerEl = this._elem.querySelector('[data-current-stock]')

    if (!currentStockEl || !currentStockIntegerEl) return

    let currentStockThreshold = parseInt(currentStockEl.dataset.currentStockThreshold, 10);
    let inventoryQuantity = this._productVariantInventories.find(item => item.id === variant.id).inventory_quantity

    if (this._product['handle'] === "damson-madder-gift-card") {
      if (inventoryQuantity < 0) {
        inventoryQuantity = 1000000
      }
    }

    if (inventoryQuantity > currentStockThreshold || inventoryQuantity < 1) {
      currentStockEl.classList.add('hide')
    } else {
      currentStockIntegerEl.innerHTML = inventoryQuantity
      currentStockEl.classList.remove('hide')
    }

    for (let select of this._quantitySelects) {
      select.setAttribute('max', inventoryQuantity)

      if (Number(select.value) > Number(inventoryQuantity)) {
        select.value = Number(inventoryQuantity)
      }
    }
  }

  _updateHistoryState(variant) {
    if (!history.replaceState || !variant) {
      return
    }
    let newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${variant.id}`
    window.history.replaceState({ path: newurl }, '', newurl)
  }

  _updateAddToCartState(variant) {
    if (!variant && this._product.available) {
      for (let addToCart of this._addToCarts) {
        addToCart.setAttribute('disabled', 'disabled')
        addToCart.innerHTML = this._ctx.getState().locale.makeASelection
      }
      return
    }

    if (!variant) {
      return
    }

    if (variant.available) {
      for (let [i, addToCart] of this._addToCarts.entries()) {
        addToCart.classList.remove('is-disabled')
        addToCart.innerHTML = this._addToCartHTML[i]
      }
    } else {
      for (let addToCart of this._addToCarts) {
        addToCart.classList.add('is-disabled')
        addToCart.innerHTML = this._ctx.getState().locale.soldOut
      }
    }
  }

  _switchToVariantImage(variant) {
    for (let productImage of this._images) {
      if (productImage.dataset.productImage) {
        let idArray = productImage.dataset.productImage.split(',')
        if (idArray.includes(variant.id.toString())) {
          if (this._gallery.mainSlider?.component?._slider) {
            this._gallery.mainSlider.component.goToSlide(productImage.dataset.index)
          }

          if (this._gallery.thumbsSlider?.component?._slider) {
            this._gallery.thumbsSlider.component.goToSlide(productImage.dataset.index)
          }

          if (this._gallery.modalSlider?.component?._slider) {
            this._gallery.modalSlider.component.goToSlide(productImage.dataset.index)
          }
        }
      }
    }
  }

  _updateOptionLabels(variant) {
    for (const [index, label] of this.activeOptionLabels.entries()) {
      label.innerText = variant.options[index]
    }
  }

  _updateProductPrices(variant) {
    for (let varies of this._priceVaries) {
      varies.classList.add('hide')
    }

    for (let productPrice of this._prices) {
      if (variant.compare_at_price > variant.price) {
        productPrice.classList.add('on-sale')
      } else {
        productPrice.classList.remove('on-sale')
      }
      productPrice.innerHTML = this._formatMoney(variant.price)
    }

    for (let productComparePrice of this._comparePrices) {
      if (variant.compare_at_price > variant.price) {
        productComparePrice.classList.remove('hide')
        productComparePrice.innerHTML = this._formatMoney(variant.compare_at_price)
      } else {
        productComparePrice.classList.add('hide')
        productComparePrice.innerHTML = ''
      }
    }

    if (!variant.available) {
      for (let productComparePrice of this._comparePrices) {
        productComparePrice.classList.add('hide')
      }
    }
  }

  _formatMoney(price) {
    return Helpers.formatMoney(price, this._ctx.getState().moneyFormat)
  }

  _updateMasterSelect(variant) {
    for (let originalSelector of this._masterSelects) {
      originalSelector.value = variant.id
    }
  }

  _getCurrentOptions() {
    let currentOptions = []

    for (let optionSelector of this._variantOptionTriggers) {
      let type = optionSelector.getAttribute('type')
      let currentOption = {}
      let alreadyDone = false

      for (let option of currentOptions) {
        if (option.index === optionSelector.dataset.index) {
          alreadyDone = true
        }
      }
      if (alreadyDone) continue

      if (type === 'radio' || type === 'checkbox') {
        if (optionSelector.checked) {
          currentOption.value = optionSelector.value
          currentOption.index = optionSelector.dataset.index
          currentOptions.push(currentOption)
        } else {
          currentOptions.push(false)
        }
      } else {
        currentOption.value = optionSelector.value
        currentOption.index = optionSelector.dataset.index
        currentOptions.push(currentOption)
      }
    }
    currentOptions = Helpers.compact(currentOptions)
    return currentOptions
  }

  _getVariantFromOptions() {
    let selectedValues = this._getCurrentOptions()
    let variants = this._product.variants
    let found = false

    if (selectedValues.length !== this._product.options.length) {
      return null
    }

    for (let variant of variants) {
      var satisfied = true

      for (let option of selectedValues) {
        if (satisfied) {
          satisfied = (option.value === variant[option.index])
        }
      }

      if (satisfied) {
        found = variant
      }
    }

    return found || null
  }

  _handleCarouselControls() {
    this._handleGalleryThumbClick();
    this._handleGalleryMainChange();
  }

  /**
   * On thumbnail click, change active image on the main slider.
   */
  _handleGalleryThumbClick() {
    if (!this._gallery.mainSlider || !this._gallery?.thumbs.length) {
      return
    }

    for (const [index, thumb] of this._gallery.thumbs.entries()) {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        this._gallery.mainSlider.component.goToSlide(index)
      })
    }
  }

  /**
   * On change of the main slider, change active image on thumbs.
   */
  _handleGalleryMainChange() {
    if (!this._gallery.mainSlider || !this._gallery?.thumbs.length) {
      return
    }

    this._gallery.mainSlider.component._localCtx.on('slide-change', (state, data) => {
      if (this._gallery?.thumbSlider?.component?._slider) {
        this._gallery.thumbSlider.component.goToSlide(data.slide)
      }

      if (this._gallery?.modalSlider?.component?._slider) {
        this._gallery.modalSlider.component.goToSlide(data.slide)
      }
    })
  }


  /**
   * Move the automatically inserted Clearpay
   * element to the designed spot.
   */
  _moveClearpayElement() {
    if (!this._clearpayTarget) {
      return
    }

    let clearpayExists = setInterval(() => {
      this._clearpayElem = document.querySelector('.clearpay-paragraph')
      if (!this._clearpayElem) {
        return
      }

      clearInterval(clearpayExists);

      let newClone = this._clearpayElem.cloneNode(true)
      const newElem = document.createElement('p')
      newElem.classList.add('clearpay-paragraph')
      newElem.setAttribute('data-product-id', this._product.id)

      this._clearpayTarget.insertAdjacentElement('afterbegin', newClone)
      this._clearpayElem.remove()
    }, 750)

  }
}